import React from 'react'
import SeoPage from '../components/SeoPage'

import Img from '../components/Image'
import { graphql, Link } from 'gatsby'

const ContentPage = ({ data, location, ...props }) => {
    return (
        <SeoPage
            leadImage={data.img0.childImageSharp.fluid.src}
            location={location}
            title="Quelles sont les règles d'alcool au volant pour les moins de 22 ans?"
            description="Vous avez été intercepté au volant d’un véhicule pour alcool au volant alors que vous êtes âgé de 21 ans ou moins? Avocats Alcool au Volant vous explique toutes les conséquences!"
            fr={undefined}
            lawType="criminal"
            specialtyText="spécialisé en droit criminel">
            <p>
                En dessous de 22 ans, vous avez <strong>tolérance zéro</strong>{' '}
                lorsqu’il est question d’alcool au volant. En effet, la fameuse
                règle du « 0.08 » ne s'applique qu’après avoir célébré votre 22e
                anniversaire.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img0.childImageSharp.fluid}
                    title="Ai-je le droit de boire avant de conduire si j’ai moins de 22 ans?"
                    alt=""
                />
            </p>
            <p>
                Évidemment, si vous êtes intercepté au volant d’un véhicule et
                que le policier détecte une certaine quantité d’alcool dans
                votre sang, les conséquences seront sérieuses et pourront vous
                suivre pendant plusieurs années.
            </p>
            <p>
                <strong>
                    Avocats Alcool au Volant vous explique tout ce qu’il faut
                    savoir sur les règles d’alcool au volant avant 22 ans.
                </strong>
            </p>
            <h2>
                Quelles sont les limites d’alcool lorsque vous avez 21 ans et
                moins?
            </h2>
            <p>
                Comme mentionné, en dessous de 22 ans, vous avez une tolérance
                zéro sur la consommation d’alcool. Ainsi, dès que vous consommez
                un verre, vous ne pourrez pas prendre le volant.{' '}
            </p>
            <p>
                Cette règle est valable tant pour les véhicules automobiles que
                pour les autres classes de permis (les motos par exemple).
            </p>
            <p>
                <Img
                    fluid={data.img1.childImageSharp.fluid}
                    title="Quelles sont les limites d’alcool pour les 21 ans et moins?"
                    alt=""
                />
            </p>
            <p>
                <strong>Bon à savoir! </strong>Une fois que vous aurez célébré
                votre 22e anniversaire, la limite de consommation d’alcool
                passera à 80 mg d’alcool pour 100 ml de sang.
            </p>
            <p>
                Cependant, l’alcool n’est certainement pas la seule substance
                prohibée. Vous aurez également l’interdiction de consommer du
                cannabis et toute autre drogue.{' '}
            </p>
            <p>
                Selon votre niveau d’alcool, plusieurs sanctions peuvent
                s’appliquer dès l’interception par les policiers jusqu’à la
                déclaration de culpabilité devant le juge:
            </p>
            <ul>
                <li>La contravention,</li>
                <li>Les points d’inaptitude (ou la suspension du permis), </li>
                <li>La peine d’emprisonnement, ou </li>
                <li>L’interdiction de conduire. </li>
            </ul>
            <h3>En dessous du « 0.08 »</h3>
            <p>
                Si vous êtes intercepté au volant du véhicule avec un taux
                d’alcoolémie inférieur à 0.08, certaines conséquences vont
                s’appliquer si vous êtes âgés de moins de 22 ans:
            </p>
            <ul>
                <li>Suspension du permis pour une période de 90 jours,</li>
                <li>4 points d’inaptitude, et</li>
                <li>Une contravention entre 300$ et 600$.</li>
            </ul>
            <p>
                En revanche, à ce stade, il faut aussi garder à l’esprit que
                vous avez un{' '}
                <strong>nombre limité de points d’inaptitude</strong> que vous
                pouvez recevoir avant que votre permis soit annulé:
            </p>
            <table>
                <tr>
                    <td>
                        <p>
                            <strong>Permis de conduire</strong>
                        </p>
                    </td>
                    <td>
                        <p>
                            <strong>Point d’inaptitude limite</strong>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>
                            Permis d’apprenti conducteur (ou permis probatoire)
                        </p>
                    </td>
                    <td>
                        <p>4 points</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Permis de conduire pour les 22 ans et moins</p>
                    </td>
                    <td>
                        <p>8 points</p>
                    </td>
                </tr>
            </table>
            <p>
                <strong>Qu’arrive-t-il si j’atteins le nombre limite?</strong>{' '}
                Dès que vous atteignez le nombre limité de points d’inaptitude,
                votre permis de conduire sera automatiquement annulé. Ceux-ci
                sont comptabilisés sur plusieurs années selon vos diverses
                infractions.{' '}
            </p>
            <h3>« 0.08 » et plus</h3>
            <p>
                Que vous ayez moins de 22 ans ou non, les conséquences sont les
                mêmes dès que vous êtes intercepté au volant d’un véhicule avec
                un taux d’alcool supérieur à « 0.08 ». Les conséquences vont
                varier s’il s’agit de{' '}
                <Link to="https://avocatsalcoolauvolant.ca/premiere-infraction-alcool-volant/">
                    votre première infraction
                </Link>{' '}
                ou s’il est question de récidives.{' '}
            </p>
            <p>
                <Img
                    fluid={data.img2.childImageSharp.fluid}
                    title="Quelles sont les conséquences de l’alcool au volant"
                    alt=""
                />
            </p>
            <p>
                <strong>
                    S’il s’agit de votre première infraction d’alcool au volant
                </strong>
                , les conséquences immédiates au moment de l’arrestation sont:
            </p>
            <ul>
                <li>
                    La suspension du permis pour une période qui varie entre 24h
                    et 90 jours, et{' '}
                </li>
                <li>
                    Une saisie du véhicule pour une période de 30 jours (selon
                    la situation).
                </li>
            </ul>
            <p>
                La saisie du véhicule aura lieu si vous êtes intercepté au
                volant du véhicule avec un taux d’alcool de 0.16,{' '}
                <strong>soit le double de la limite permise</strong>.{' '}
            </p>
            <p>
                <strong>
                    Ai-je le droit de refuser de souffler dans l’alcootest?
                </strong>{' '}
                Si vous r
                <Link to="https://avocatsalcoolauvolant.ca/refus-souffler-alcootest/">
                    efusez de souffler dans l’alcootest
                </Link>
                , cela permettra au policier d’avoir les motifs raisonnables
                afin d’agir comme si vous aviez un taux supérieur à la limite
                permise. Il est donc préférable d’obtempérer.{' '}
            </p>
            <p>
                Par la suite, si vous êtes reconnu coupable d’avoir conduit avec
                les facultés affaiblies, vous ferez face à des conséquences en
                vertu du <em>Code de la sécurité routière</em>, mais également
                du <em>Code criminel</em>.
            </p>
            <p>
                <strong>
                    Les conséquences en vertu du{' '}
                    <em>Code de la sécurité routière</em>:
                </strong>
            </p>
            <ul>
                <li>
                    Interdiction de conduire pour 1 an et révocation du permis
                    pour une période de 1 à 3 ans,
                </li>
                <li>
                    Inscription au{' '}
                    <em>
                        Programme d’évaluation et de réduction du risque de
                        conduire avec les capacités affaiblies
                    </em>
                    , et{' '}
                </li>
                <li>
                    Inscription au programme <em>Alcofrein</em>.
                </li>
            </ul>
            <p>
                Ces conséquences ne sont toutefois pas automatiques. En effet,
                le juge aura la discrétion de vous imposer les sanctions qu’il
                juge appropriées.
            </p>
            <p>
                <strong>
                    Les conséquences en vertu du <em>Code criminel</em>:
                </strong>
            </p>
            <ul>
                <li>Un casier judiciaire,</li>
                <li>Une contravention d’au moins 1 000 $, </li>
                <li>Une interdiction de conduire pour au moins 1 an.</li>
            </ul>
            <p>
                En plus de ces coûts, il faudra s’attendre à payer plusieurs
                frais, notamment{' '}
                <strong>l’augmentation de la prime d’assurance</strong>, tous
                les coûts relatifs aux programmes et ceux de votre casier
                judiciaire.{' '}
            </p>
            <p>
                Ces conséquences ne s’appliquent que lorsque vous en êtes à
                votre première infraction. Les conséquences en cas de récidives
                sont encore plus sévères et peuvent rester pour toujours. Vous
                ferez même face à une d’éventuelles peines d’emprisonnement.{' '}
            </p>
            <p>
                <strong>
                    Accusé d’alcool au volant? Avocats Alcool au Volant vous
                    permet de trouver un professionnel pour vous défendre
                    gratuitement!
                </strong>
            </p>
            <h2>
                Dois-je être en train de conduire le véhicule pour être arrêté?
            </h2>
            <p>
                Non, pour être accusé d’alcool au volant, vous n’avez pas besoin
                d’être en train de conduire le véhicule. L’infraction ne fait
                aucune distinction entre un véhicule à l’arrêt ou un véhicule en
                mouvement.
            </p>
            <p>
                <Img
                    fluid={data.img3.childImageSharp.fluid}
                    title="Puis-je être arrêté pour alcool au volant si je dors dans mon auto?"
                    alt=""
                />
            </p>
            <p>
                Il suffit d’avoir{' '}
                <strong>la garde ou le contrôle du véhicule</strong> afin que
                des accusations puissent être portées contre vous. En d’autres
                termes, si vous aviez la possibilité de mettre le véhicule en
                mouvement, cela est suffisant. Ce notamment le cas:
            </p>
            <ul>
                <li>Si votre ceinture est bouclée,</li>
                <li>
                    Si vous utilisez le chauffage ou la radio du véhicule, ou
                </li>
                <li>
                    Si vous avez les clés du véhicule ou si vous y avez accès.
                </li>
            </ul>
            <p>
                Évidemment, tout est une question de contexte et ce sera au juge
                de rendre une décision selon la preuve qui sera faite.
                Toutefois, dès que vous entrez dans un véhicule, vous êtes à
                risque d’être arrêté pour alcool au volant.
            </p>
            <h2>
                Avocats Alcool au Volant vous permet de trouver un avocat
                criminaliste gratuitement!
            </h2>
            <p>
                Dès que vous êtes intercepté au volant d’un véhicule, les
                policiers ont plusieurs règles à respecter. L’un des droits est
                bien évidemment celui d’être représenté par un{' '}
                <Link to="https://avocatsalcoolauvolant.ca/avocat-criminel-alcool-volant/">
                    avocat spécialisé en droit criminel
                </Link>
                . Cela vous permet d’être certain que les procédures respectent
                toutes les règles.{' '}
            </p>
            <p>
                Vous êtes accusé d’alcool au volant et vous ne savez pas quoi
                faire? Avocats Alcool au Volant est là pour vous!
            </p>
            <p>
                <strong>
                    Vous n’avez qu’à remplir le formulaire en ligne gratuitement
                    et on se charge du reste pour vous!
                </strong>
            </p>
        </SeoPage>
    )
}

export default ContentPage

export const pageQuery = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
        img0: file(
            relativePath: {
                eq: "alcool-volant-limites/boire-avant-conduite.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img1: file(
            relativePath: {
                eq: "alcool-volant-limites/limite-alcool-conduite.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img2: file(
            relativePath: {
                eq: "alcool-volant-limites/consequence-alcool-volant.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
        img3: file(
            relativePath: {
                eq: "alcool-volant-limites/alcool-volant-stationne.jpeg"
            }
        ) {
            childImageSharp {
                fluid(maxWidth: 960) {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
`
